module.exports = __webpack_public_path__ + "535877f50039c0cb49a6196a5b7517cd.woff";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 321
// module chunks = 0